// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CodePreviewComponent } from './code-preview.component';
import { CoreModule } from '../../../../../core/core.module';
import { HighlightModule } from 'ngx-highlightjs';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        HighlightModule,
        PerfectScrollbarModule,
        ClipboardModule,
        NgbNavModule,
        NgbTooltipModule,
    ],
    exports: [CodePreviewComponent],
    declarations: [CodePreviewComponent],
})
export class CodePreviewModule {}
